import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { type UpgradeDays, UpgradePage } from "@/features/upgrade/UpgradePage";
import { upgradeReportQuery } from "@/lib/api/queries";
import { projectSearch } from "@/lib/search";

const search = projectSearch.extend({
  days: z.union([z.literal(7), z.literal(30), z.literal(90)]).optional(),
});

const DEFAULT_DAYS: UpgradeDays = 30;

/**
 * NEW-46 WP5: a deliberate visit, reached from Settings or a job's probe badge — never
 * linked from the sidebar, never prefetched from Home.
 */
export const Route = createFileRoute("/w/$workspace/p/$project/upgrade")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ days: s.days ?? DEFAULT_DAYS }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(
      upgradeReportQuery(params.workspace, params.project, deps.days),
    ),
  component: UpgradeRoute,
});

function UpgradeRoute() {
  const { workspace, project } = Route.useParams();
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <UpgradePage
      workspace={workspace}
      project={project}
      days={s.days ?? DEFAULT_DAYS}
      onDays={(days) =>
        navigate({
          search: (prev) => ({ ...prev, days: days === DEFAULT_DAYS ? undefined : days }),
          replace: true,
        })
      }
    />
  );
}
